import cn from 'classnames'
import { Link } from 'react-router-dom'

import { CallToActionProps } from './CallToAction.types'

export const CallToAction = (props: CallToActionProps) => {
    const { className } = props

    return (
        <section className={cn('py-20 bg-primary text-white', className)}>
            <div className='container mx-auto px-4 text-center'>
                <h2 className='text-4xl font-bold mb-6'>Ready to save time?</h2>
                <p className='text-xl mb-12 text-primary-light'>Discover how Nexly can streamline your workflow</p>
                <div className='flex flex-col sm:flex-row gap-4 justify-center'>
                    <Link to='/contacts' className='px-10 py-5 bg-white text-primary text-lg font-semibold rounded-lg hover:bg-gray-100 transition-colors shadow-lg inline-block text-center'>
                        Contact us
                    </Link>

                </div>
            </div>
        </section>
    )
}
